/* eslint-disable react/prop-types */
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import fixTableCellWidth from "utils/fixTableCellWidth";
import separate from "utils/separate";


function Row(props) {
    const { row } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={separate(Number(row.amount))}
                    style={fixTableCellWidth("150px")}>{separate(Number(row.amount))} تومان</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.balance))}
                    style={fixTableCellWidth("150px")}>{separate(Number(row.balance))} تومان</TableCell>
                <TableCell className="tablecell" align="left" title={row?.ghollak?.name}
                    style={fixTableCellWidth("150px")}>{row?.ghollak?.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row.type_name}
                    style={fixTableCellWidth("110px")}>{row.type_name}</TableCell>
                <TableCell className="tablecell" align="left" title={new Date(row.created_at).toLocaleString("fa-IR")}
                    style={fixTableCellWidth("170px")}>{new Date(row.created_at).toLocaleString("fa-IR")}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function InvestmentTransactionsTable({ data }) {
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead sx={{ padding: 0 }}>
                    <TableRow>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>مقدار</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>موجودی</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام قلک</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("110px")}>نوع</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>تاریخ ایجاد</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody style={{ display: "block" }}>
                    {data.map((row) => (
                        <Row key={row.id} row={row} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
